<template>
    <kgr-input-group
        :label="label"
        :tooltip="tooltip"
        :required="required"
        :inline="inline"
        :error-message="errorMessage"
    >
        <slot></slot>
    </kgr-input-group>
</template>

<script>
import Error from '../../../js/model/Error';
import InputGroup from './InputGroup';

export default {
    components: {
        'kgr-input-group': InputGroup,
    },
    props: {
        label: {
            type: String,
            required: false,
        },
        fieldName: {
            type: String,
            required: true,
        },
        tooltip: {
            type: String,
            required: false,
        },
        error: {
            type: Error,
            required: true,
        },
        required: {
            type: Boolean,
            required: false,
        },
        inline: {
            type: Boolean,
            required: false,
        },
    },

    computed: {
        /**
         * Translated per message, then joined. The row used to render whatever the API sent verbatim, which
         * worked only as long as constraint messages were prose; a translation key - the pattern the API
         * already uses for valueToLong and endDateBeforeStartDate - reached the user as the key itself.
         * Translating the joined string instead would miss whenever a field carries two violations.
         */
        errorMessage() {
            const messages = this.error.messagesForField(this.fieldName, true);
            if (messages === null) {
                return null;
            }

            return messages.map((message) => this.$t(message)).join(' ');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
